import React from 'react';
import { PreviewErrorPage } from './preview-error';

export default function render(entry) {
    return <PreviewErrorPage {...entry} />;
}
